const copyButtons = document.querySelectorAll('.icon-social--copy');

copyButtons.forEach((button) => {
	button.addEventListener('click', () => {
		const url = button.getAttribute('data-url');
		if (url) {
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(url).catch((err) => {
					// eslint-disable-next-line no-console
					console.error('Failed to copy link: ', err);
				});
			}
		}
	});
});
